module.exports = __webpack_public_path__ + "img/avatar_11.c83949ed.jpg";